module.exports = __webpack_public_path__ + "img/activity_03.e9258dfb.jpg";